import { UserWithProviders } from "@/auth/types";

export const isFeideUser = (user: UserWithProviders) => {
  return user?.publicMetadata?.isFeideUser === true;
};

export const isFeideUserFromSession = (
  sessionClaims: CustomJwtSessionClaims | null | undefined,
): boolean => {
  return sessionClaims?.publicMeta?.isFeideUser === true;
};

export const ensureE164Format = (phone: string) => {
  // if is digits and 8 characters long, assume it's a Norwegian number without country code
  if (/^\d{8}$/.test(phone)) {
    return `+47${phone}`;
  }
  // if starts with 00, replace with +
  if (phone.startsWith("00")) {
    return `+${phone.slice(2)}`;
  }
  // if starts with +, assume it's in E.164 format
  if (phone.startsWith("+")) {
    return phone;
  }
  // otherwise, return as is
  return phone;
};
